import {
    Component,
    ElementRef,
    NgZone,
    ViewChild,
    Inject,
    Optional,
    OnInit,
    Input,
    EventEmitter,
    Output,
    OnChanges,
    SimpleChanges,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { RoleService } from "app/main/services/roles.service";
import { TranslateService } from "@ngx-translate/core";

import {
    MatAutocompleteSelectedEvent,
    MatAutocomplete,
} from "@angular/material/autocomplete";
import { map, startWith } from "rxjs/operators";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { MatChipInputEvent } from "@angular/material/chips";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { SujetoObligado } from "app/main/models/sujeto-obligado.model";
import { TipoSujetoObligado } from "app/main/models/tipo-sujeto-obligado.model";
import { TipoDocumentoService } from "app/main/services/tipo-documento.service";
import { TipoSujetoObligadoService } from "app/main/services/tipo-sujeto-obligado.service";
import { TipoDocumento } from "app/main/models/tipo-documento.model";
import { PaisService } from "app/main/services/pais.service";
import { SectorActividadService } from "app/main/services/sector-actividad.service";
import { ProfesionService } from "app/main/services/profesion.service";
import { PersonaFisica } from "app/main/models/persona-fisica.model";
import { PersonaJuridica } from "app/main/models/persona-juridica.model";
import { Contacto } from "app/main/models/contacto.model";
import { Cliente } from "app/main/models/cliente.model";
import { ClienteGeneralData } from "app/main/models/cliente-general-data.model";
import { timingSafeEqual } from "crypto";
import { DocumentoDeIdentidad } from "app/main/models/documento-de-identidad.model";
import { RazonSocial } from "app/main/models/razon-social.model";
import { Direccion } from "app/main/models/direccion.model";
import { CorreoElectronico } from "app/main/models/correo-electronico.model";
import { Telefono } from "app/main/models/telefono.model";

@Component({
    selector: "cliente",
    templateUrl: "./cliente.component.html",
    styleUrls: ["./cliente.component.scss"],
})
export class ClienteComponent implements OnChanges {
    //How to use cliente and tipo bi-directional data binding

    @Input() eventoRecibido: any;
    @Input() tipo: string;
    @Input() cliente: any;
    @Input() sujetoObligado: SujetoObligado;
    @Input() action: string;
    @Output() onClienteChange = new EventEmitter<any>();
    @Output() tipoChange = new EventEmitter<string>();

    tipos = [
        { nombre: "Persona física", value: "PERSONA_FISICA" },
        { nombre: "Persona jurídica", value: "PERSONA_JURIDICA" },
    ];

    displayedColumnsEvaluaciones: string[] = [
        "nombre",
        "estado",
        "version",
        "estructuraJerarquica",
        "creador",
        "dueno",
        "fechaInicio",
        "fechaFin",
    ];

    razonSocialPais: any;
    GENERAL_DATA: ClienteGeneralData = new ClienteGeneralData({});

    //handle GENERAL_DATA changes

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    tiposDocumentos = [];
    tiposSujetos = [];
    tiposSectorIndustrial = [];
    tiposProfesiones = [];
    paises = [];
    displayedColumns: string[] = ["estructura", "nombre"];

    constructor(
        private roleService: RoleService,
        public translate: TranslateService,
        private serviceTipoSujetoObligado: TipoSujetoObligadoService,
        private serviceTipoDocumento: TipoDocumentoService,
        private servicePais: PaisService,
        private serviceSectorIndustrial: SectorActividadService,
        private serviceProfesion: ProfesionService
    ) {
        console.log("Datos del cliente", this.cliente);

    }

    @ViewChild("usuarioInput") usuarioInput: ElementRef<HTMLInputElement>;
    @ViewChild("auto") matAutocomplete: MatAutocomplete;

    ngOnChanges(changes: SimpleChanges) {
        if (changes.eventoRecibido) {
            this.doAction();
        }
    }

    doAction(): void {
        if (this.action == "Add") {
            if (this.tipo == "PERSONA_FISICA") {
                this.cliente.personaJuridica = null;
            }

            if (this.tipo == "PERSONA_JURIDICA") {
                this.cliente.personaFisica = null;
            }

            if (this.tipo == "PERSONA_FISICA") {
                this.cliente.personaFisica = new PersonaFisica(
                    this.GENERAL_DATA
                );
                this.cliente.personaFisica.sectorIndustrial =
                    this.GENERAL_DATA.sectorIndustrial;
                this.cliente.personaFisica.contacto = new Contacto({});
                this.cliente.personaFisica.segundoNombre =
                    this.GENERAL_DATA.segundoNombre;
                this.cliente.personaFisica.segundoApellido =
                    this.GENERAL_DATA.segundoApellido;
                this.cliente.personaFisica.personaPoliticamenteExpuesta =
                    this.GENERAL_DATA.personaPoliticamenteExpuesta;

                //this.cliente.personaFisica.contacto.addCorreo(this.GENERAL_DATA.correoElectronico);
                if (
                    this.GENERAL_DATA.correoElectronico != null &&
                    this.GENERAL_DATA.correoElectronico != ""
                ) {
                    let correoElectronico = new CorreoElectronico({});
                    correoElectronico.correo =
                        this.GENERAL_DATA.correoElectronico;
                    this.cliente.personaFisica.contacto.addCorreo(
                        correoElectronico
                    );
                }
                this.cliente.personaFisica.contacto.addTelefono(
                    this.GENERAL_DATA.telefono
                );
                this.GENERAL_DATA.direccionFisica.tipo = "FISICA";
                this.cliente.personaFisica.contacto.addDireccion(
                    this.GENERAL_DATA.direccionFisica
                );
                this.cliente.personaFisica.documentoIdentidad =
                    new DocumentoDeIdentidad(
                        this.GENERAL_DATA.documentoIdentidad
                    );
                this.cliente.personaFisica.fechaNacimiento = new Date(
                    this.GENERAL_DATA.fechaNacimiento
                );
            }

            if (this.tipo == "PERSONA_JURIDICA") {
                this.cliente.personaJuridica = new PersonaJuridica(
                    this.GENERAL_DATA
                );
                this.cliente.personaJuridica.sectorIndustrial =
                    this.GENERAL_DATA.sectorIndustrial;
                this.cliente.personaJuridica.contacto = new Contacto({});

                if (
                    this.GENERAL_DATA.correoElectronico != null &&
                    this.GENERAL_DATA.correoElectronico != ""
                ) {
                    let correoElectronico = new CorreoElectronico({});
                    correoElectronico.correo =
                        this.GENERAL_DATA.correoElectronico;
                    this.cliente.personaJuridica.contacto.addCorreo(
                        correoElectronico
                    );
                }
                this.cliente.personaJuridica.contacto.addTelefono(
                    this.GENERAL_DATA.telefono
                );
                this.GENERAL_DATA.direccionFisica.tipo = "FISICA";
                this.cliente.personaJuridica.contacto.addDireccion(
                    this.GENERAL_DATA.direccionFisica
                );
                this.GENERAL_DATA.direccionFiscal.tipo = "FISCAL";
                this.cliente.personaJuridica.contacto.addDireccion(
                    this.GENERAL_DATA.direccionFiscal
                );
                this.cliente.personaJuridica.razonSocial = new RazonSocial(
                    this.GENERAL_DATA.razonSocial
                );
                this.cliente.personaJuridica.nombre = this.GENERAL_DATA.nombre;
            }
        }

        if (this.action == "Update") {
            if (this.tipo == "PERSONA_FISICA") {
                if (this.GENERAL_DATA.contacto == null) {
                    this.GENERAL_DATA.contacto = new Contacto({});
                }

                this.GENERAL_DATA.sectorIndustrial =
                    this.cliente.personaFisica.sectorIndustrial;
                this.GENERAL_DATA.correoElectronico =
                    this.cliente.personaFisica.contacto != null
                        ? this.cliente.personaFisica.contacto.correoElectronico
                        : "";
                this.GENERAL_DATA.telefono =
                    this.cliente.personaFisica.contacto != null &&
                    this.cliente.personaFisica.contacto.telefonos != null &&
                    this.cliente.personaFisica.contacto.telefonos.length > 0
                        ? this.cliente.personaFisica.contacto.telefonos[0]
                        : new Telefono({});
                this.GENERAL_DATA.documentoIdentidad = new DocumentoDeIdentidad(
                    this.cliente.personaFisica.documentoIdentidad
                );
                this.GENERAL_DATA.personaPoliticamenteExpuesta =
                    this.cliente.personaFisica.personaPoliticamenteExpuesta;
                this.GENERAL_DATA.fechaNacimiento = new Date(
                    this.cliente.personaFisica.fechaNacimiento
                );
                this.GENERAL_DATA.profesion =
                    this.cliente.personaFisica.profesion;
                this.GENERAL_DATA.nombre = this.cliente.personaFisica.nombre;
                this.GENERAL_DATA.apellido =
                    this.cliente.personaFisica.apellido;
                this.GENERAL_DATA.lugarNacimiento =
                    this.cliente.personaFisica.lugarNacimiento;
                this.GENERAL_DATA.direccionFisica =
                    this.cliente.personaFisica.contacto != null &&
                    this.cliente.personaFisica.contacto.direcciones != null &&
                    this.cliente.personaFisica.contacto.direcciones.length > 0
                        ? this.getDireccionByType(
                              "FISICA",
                              this.cliente.personaFisica.contacto.direcciones
                          )
                        : new Direccion({});
                this.GENERAL_DATA.segundoNombre =
                    this.cliente.personaFisica.segundoNombre;
                this.GENERAL_DATA.segundoApellido =
                    this.cliente.personaFisica.segundoApellido;
            }

            if (this.tipo == "PERSONA_JURIDICA") {
                this.GENERAL_DATA.sectorIndustrial =
                    this.cliente.personaJuridica.sectorIndustrial;
                this.GENERAL_DATA.correoElectronico =
                    this.cliente.personaJuridica.contacto != null
                        ? this.cliente.personaJuridica.contacto
                              .correoElectronico
                        : "";
                this.GENERAL_DATA.telefono =
                    this.cliente.personaJuridica.contacto != null &&
                    this.cliente.personaJuridica.contacto.telefonos != null &&
                    this.cliente.personaJuridica.contacto.telefonos.length > 0
                        ? this.cliente.personaJuridica.contacto.telefonos[0]
                        : new Telefono({});

                this.GENERAL_DATA.razonSocial =
                    this.cliente.personaJuridica.razonSocial != null
                        ? new RazonSocial(
                              this.cliente.personaJuridica.razonSocial
                          )
                        : new RazonSocial({});
                this.GENERAL_DATA.nombreFiscal =
                    this.cliente.personaJuridica.nombreFiscal;
                this.GENERAL_DATA.nombre = this.cliente.personaJuridica.nombre;

                this.GENERAL_DATA.direccionFisica =
                    this.cliente.personaJuridica.contacto != null &&
                    this.cliente.personaJuridica.contacto.direcciones != null &&
                    this.cliente.personaJuridica.contacto.direcciones.length > 0
                        ? this.getDireccionByType(
                              "FISICA",
                              this.cliente.personaJuridica.contacto.direcciones
                          )
                        : new Direccion({});

                this.GENERAL_DATA.direccionFiscal =
                    this.cliente.personaJuridica.contacto != null &&
                    this.cliente.personaJuridica.contacto.direcciones != null &&
                    this.cliente.personaJuridica.contacto.direcciones.length > 0
                        ? this.getDireccionByType(
                              "FISCAL",
                              this.cliente.personaJuridica.contacto.direcciones
                          )
                        : new Direccion({});
            }
        }

        this.cliente.tipo = this.tipo;
        this.GENERAL_DATA.tipo = this.tipo;
        this.onClienteChange.emit(this.GENERAL_DATA);
        this.tipoChange.emit(this.GENERAL_DATA.tipo);
    }

    doUpdate(): void {
        //if (this.action == "Update") {
            if (this.tipo == "PERSONA_FISICA") {
                var cambioDeTipo: Boolean = false;
                if (this.cliente.personaFisica == null) {
                    this.cliente.personaFisica = new PersonaFisica({});
                    cambioDeTipo = true;
                }

                if (this.cliente.personaFisica.contacto == null) {
                    this.cliente.personaFisica.contacto = new Contacto({});
                } else {
                    this.cliente.personaFisica.contacto = new Contacto(
                        this.cliente.personaFisica.contacto
                    );
                }

                this.cliente.personaFisica.sectorIndustrial =
                    this.GENERAL_DATA.sectorIndustrial;
                this.cliente.personaFisica.correoElectronico =
                    this.GENERAL_DATA.correoElectronico;

                if (
                    this.cliente.personaFisica.contacto != null &&
                    this.cliente.personaFisica.contacto.telefonos != null &&
                    this.cliente.personaFisica.contacto.telefonos.length > 0
                ) {
                    this.cliente.personaFisica.contacto.telefonos[0] =
                        this.GENERAL_DATA.telefono;
                }
                this.cliente.personaFisica.documentoIdentidad =
                    new DocumentoDeIdentidad(
                        this.GENERAL_DATA.documentoIdentidad
                    );
                this.cliente.personaFisica.personaPoliticamenteExpuesta =
                    this.GENERAL_DATA.personaPoliticamenteExpuesta;
                this.cliente.personaFisica.fechaNacimiento = new Date(
                    this.GENERAL_DATA.fechaNacimiento
                );
                this.cliente.personaFisica.profesion =
                    this.GENERAL_DATA.profesion;
                this.cliente.personaFisica.nombre = this.GENERAL_DATA.nombre;
                this.cliente.personaFisica.segundoNombre =
                    this.GENERAL_DATA.segundoNombre;
                this.cliente.personaFisica.apellido =
                    this.GENERAL_DATA.apellido;
                this.cliente.personaFisica.segundoApellido =
                    this.GENERAL_DATA.segundoApellido;
                this.cliente.personaFisica.lugarNacimiento =
                    this.GENERAL_DATA.lugarNacimiento;

                if (
                    this.cliente.personaFisica.contacto != null &&
                    this.cliente.personaFisica.contacto.direcciones != null &&
                    this.cliente.personaFisica.contacto.direcciones.length > 0
                ) {
                    let direccionFisica = this.getDireccionByType(
                        "FISICA",
                        this.cliente.personaFisica.contacto.direcciones
                    );
                    direccionFisica = this.GENERAL_DATA.direccionFisica;
                }
                if (cambioDeTipo) {
                    this.cliente.personaFisica.documentoIdentidad.id = null;
                    this.cliente.personaFisica.contacto.id = null;
                    if (
                        this.cliente.personaFisica.contacto != null &&
                        this.cliente.personaFisica.contacto.telefonos != null &&
                        this.cliente.personaFisica.contacto.telefonos.length > 0
                    )
                        this.cliente.personaFisica.contacto.telefonos[0].id =
                            null;
                    if (
                        this.cliente.personaFisica.contacto != null &&
                        this.cliente.personaFisica.contacto.direcciones !=
                            null &&
                        this.cliente.personaFisica.contacto.direcciones.length >
                            0
                    )
                        this.cliente.personaFisica.contacto.direcciones[0].id =
                            null;
                    if (
                        this.cliente.personaFisica.contacto != null &&
                        this.cliente.personaFisica.contacto.direcciones !=
                            null &&
                        this.cliente.personaFisica.contacto.direcciones.length >
                            1
                    )
                        this.cliente.personaFisica.contacto.direcciones[1].id =
                            null;
                }

                if (
                    this.GENERAL_DATA.correoElectronico != null &&
                    this.GENERAL_DATA.correoElectronico != ""
                ) {
                    let correoElectronico = new CorreoElectronico({});
                    correoElectronico.correo =
                        this.GENERAL_DATA.correoElectronico;
                    this.cliente.personaFisica.contacto.setCorreo(
                        correoElectronico
                    );
                }

                if (this.GENERAL_DATA.telefono != null) {
                    if (
                        this.cliente.personaFisica.contacto.telefonos.length > 0
                    ) {
                        this.cliente.personaFisica.contacto.telefonos[0] =
                            this.GENERAL_DATA.telefono;
                    } else {
                        this.cliente.personaFisica.contacto.addTelefono(
                            this.GENERAL_DATA.telefono
                        );
                    }
                }

                if (this.GENERAL_DATA.direccionFisica != null) {
                    if (
                        this.cliente.personaFisica.contacto.direcciones.length >
                        0
                    ) {
                        this.cliente.personaFisica.contacto.direcciones[0] =
                            this.GENERAL_DATA.direccionFisica;
                    } else {
                        this.cliente.personaFisica.contacto.addDireccion(
                            this.GENERAL_DATA.direccionFisica
                        );
                    }
                }
            }

            if (this.tipo == "PERSONA_JURIDICA") {
                var cambioDeTipo: Boolean = false;
                if (this.cliente.personaJuridica == null) {
                    this.cliente.personaJuridica = new PersonaJuridica({});
                    cambioDeTipo = true;
                }

                if (this.cliente.personaJuridica.contacto == null) {
                    this.cliente.personaJuridica.contacto = new Contacto({});
                } else {
                    this.cliente.personaJuridica.contacto = new Contacto(
                        this.cliente.personaJuridica.contacto
                    );
                }

                this.cliente.personaJuridica.sectorIndustrial =
                    this.GENERAL_DATA.sectorIndustrial;
                this.cliente.personaJuridica.contacto.correoElectronico =
                    this.GENERAL_DATA.correoElectronico;
                this.cliente.personaJuridica.contacto.telefonos[0] =
                    this.GENERAL_DATA.telefono;
                this.cliente.personaJuridica.razonSocial =
                    this.GENERAL_DATA.razonSocial || new RazonSocial({});
                this.cliente.personaJuridica.nombreFiscal =
                    this.GENERAL_DATA.nombreFiscal;
                this.cliente.personaJuridica.nombre = this.GENERAL_DATA.nombre;
                let direccionFisica = this.getDireccionByType(
                    "FISICA",
                    this.cliente.personaJuridica.contacto.direcciones
                );
                direccionFisica = this.GENERAL_DATA.direccionFisica; //= this.getDireccionByType('FISICA',this.cliente.personaJuridica.contacto.direcciones);
                let direccionFiscal = this.getDireccionByType(
                    "FISCAL",
                    this.cliente.personaJuridica.contacto.direcciones
                );
                direccionFiscal = this.GENERAL_DATA.direccionFiscal;

                if (cambioDeTipo) {
                    this.cliente.personaJuridica.razonSocial.id = null;
                    this.cliente.personaJuridica.contacto.id = null;
                    if (
                        this.cliente.personaJuridica.contacto.telefonos.length >
                        0
                    )
                        this.cliente.personaJuridica.contacto.telefonos[0].id =
                            null;
                    if (
                        this.cliente.personaJuridica.contacto.direcciones
                            .length > 0
                    )
                        this.cliente.personaJuridica.contacto.direcciones[0].id =
                            null;
                    if (
                        this.cliente.personaJuridica.contacto.direcciones
                            .length > 1
                    )
                        this.cliente.personaJuridica.contacto.direcciones[1].id =
                            null;
                }

                if (
                    this.GENERAL_DATA.correoElectronico != null &&
                    this.GENERAL_DATA.correoElectronico != ""
                ) {
                    let correoElectronico = new CorreoElectronico({});
                    correoElectronico.correo =
                        this.GENERAL_DATA.correoElectronico;
                    this.cliente.personaJuridica.contacto.setCorreo(
                        correoElectronico
                    );
                }

                if (this.GENERAL_DATA.telefono != null) {
                    if (
                        this.cliente.personaJuridica.contacto.telefonos.length >
                        0
                    ) {
                        this.cliente.personaJuridica.contacto.telefonos[0] =
                            this.GENERAL_DATA.telefono;
                    } else {
                        this.cliente.personaJuridica.contacto.addTelefono(
                            this.GENERAL_DATA.telefono
                        );
                    }
                }

                if (this.GENERAL_DATA.direccionFisica != null) {
                    var direccionFisicaExistente = this.getDireccionByType(
                        "FISICA",
                        this.cliente.personaJuridica.contacto.direcciones
                    );
                    this.GENERAL_DATA.direccionFisica.id =
                        direccionFisicaExistente.id;
                    this.cliente.personaJuridica.contacto.addDireccion(
                        this.GENERAL_DATA.direccionFisica
                    );
                }

                if (this.GENERAL_DATA.direccionFiscal != null) {
                    var direccionFiscalExistente = this.getDireccionByType(
                        "FISCAL",
                        this.cliente.personaJuridica.contacto.direcciones
                    );
                    this.GENERAL_DATA.direccionFiscal.id =
                        direccionFiscalExistente.id;
                    this.GENERAL_DATA.direccionFiscal.tipo = "FISCAL";
                    this.cliente.personaJuridica.contacto.addDireccion(
                        this.GENERAL_DATA.direccionFiscal
                    );
                }
            }
        //}

        this.cliente.tipo = this.tipo;
            this.GENERAL_DATA.tipo = this.tipo;
        this.onClienteChange.emit(this.GENERAL_DATA);
        this.tipoChange.emit(this.GENERAL_DATA.tipo);

        //Actualizar los tipos de documento por pais y tipo
        this.getAllTipoDocumentos();
    }

    getDireccionByType(tipo: string, direcciones: any[]) {
        var direccion = direcciones.find((direccion) => direccion.tipo == tipo);
        return direccion || new Direccion({});
    }

    getAllTipoDocumentos() {
        if (this.tipo != null && this.razonSocialPais != null)
            this.serviceTipoDocumento
                .getByCountryAndTypeList(this.razonSocialPais.id, this.tipo)
                .pipe()
                .subscribe((req) => {
                    this.tiposDocumentos = req.body.map((tipo) => {
                        console.log(tipo);
                        return {
                            id: tipo.id,
                            nombre: tipo.nombre,
                            tipo: tipo.tipo,
                        };
                    });
                });
    }

    ngOnInit(): void {
        this.serviceTipoSujetoObligado
            .getList()
            .pipe()
            .subscribe((req) => {
                this.tiposSujetos = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                    };
                });
            });

        this.serviceTipoDocumento
            .getList()
            .pipe()
            .subscribe((req) => {
                this.tiposDocumentos = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                        tipo: tipo.tipo,
                    };
                });
            });

        this.servicePais
            .getList()
            .pipe()
            .subscribe((req) => {
                this.paises = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                        factorDeRiesgo: tipo.factorDeRiesgo,
                    };
                });

                this.razonSocialPais = this.paises.find(
                    (pais) =>
                        (this.cliente.personaJuridica != null &&
                            this.cliente.personaJuridica.razonSocial != null &&
                            this.cliente.personaJuridica.razonSocial.tipo!=null &&
                            pais.id ==
                                this.cliente.personaJuridica.razonSocial.tipo
                                    .pais.id) ||
                        (this.cliente.personaFisica != null &&
                            this.cliente.personaFisica.documentoIdentidad !=
                                null &&
                            this.cliente.personaFisica.documentoIdentidad.tipo !=
                            null &&
                            pais.id ==
                                this.cliente.personaFisica.documentoIdentidad
                                    .tipo.pais.id)
                );
            });

        this.serviceSectorIndustrial
            .getList()
            .pipe()
            .subscribe((req) => {
                this.tiposSectorIndustrial = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                    };
                });
            });

        this.serviceProfesion
            .getList()
            .pipe()
            .subscribe((req) => {
                this.tiposProfesiones = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                    };
                });
            });
    }

    compareObjects(o1: any, o2: any): boolean {
        var equals = false;
        if (
            o1 != null &&
            o2 != null &&
            typeof o1 === "object" &&
            typeof o2 === "object" &&
            "id" in o1 &&
            "id" in o2 &&
            o1.id === o2.id
        ) {
            equals = true;
        } else {
            equals = o1 == o2 ? true : false;
        }

        return equals;
    }

    loadDocumentsTypes() {
        this.tiposDocumentos = [];
        if (this.razonSocialPais != null)
            this.serviceTipoDocumento
                .getByCountryAndTypeList(this.razonSocialPais.id, this.tipo)
                .pipe()
                .subscribe((req) => {
                    this.tiposDocumentos = req.body.map((tipo) => {
                        console.log(tipo);
                        return {
                            id: tipo.id,
                            nombre: tipo.nombre,
                            tipo: tipo.tipo,
                        };
                    });
                });
    }

    openDialog(): void {}
}
